import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { Routes } from '€lib/routing';
import UserProfile from '€views/UserProfile';
import UserSettings from '€components/UserProfile/UserSettings';
import UserDetails from '€components/UserProfile/UserDetails';
import UserProfileHeader from '€components/UserProfile/UserProfileHeader';
import PrivacyPolicy from '€components/PrivacyPolicy';
import TermsOfUse from '€components/TermsOfUse';
import { Hidden } from '€components/Hidden';
import PasswordResetForm from '€components/PasswordResetForm';

const UserProfileRouter = () => {
    return (
        <>
            <Hidden smUp>
                <Switch>
                    <Route path={Routes.UserDetails}>
                        <Box overflow="auto" display="flex" flexDirection="column">
                            <UserProfileHeader />
                            <UserDetails />
                        </Box>
                    </Route>
                    <Route path={Routes.UserUpdatePassword}>
                        <Box overflow="auto" display="flex" flexDirection="column">
                            <UserProfileHeader />
                            <PasswordResetForm />
                        </Box>
                    </Route>
                    <Route path={Routes.UserPrivacyPolicy}>
                        <Box overflow="auto" display="flex" flexDirection="column">
                            <UserProfileHeader />
                            <PrivacyPolicy />
                        </Box>
                    </Route>
                    <Route path={Routes.UserTermsOfUse}>
                        <Box overflow="auto" display="flex" flexDirection="column">
                            <UserProfileHeader />
                            <TermsOfUse />
                        </Box>
                    </Route>
                    <Route path={Routes.UserSettings}>
                        <UserProfileHeader />
                        <Box mt={4}>
                            <UserSettings />
                        </Box>
                    </Route>
                </Switch>
            </Hidden>
            <Hidden xsDown>
                <UserProfileHeader />
                <UserProfile />
            </Hidden>
        </>
    );
};

export default UserProfileRouter;
